<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 16 16"
    fill="none"
    :width="width"
    :height="height"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M12.7803 6.21967C13.0732 6.51256 13.0732 6.98744 12.7803 7.28033L8.53033 11.5303C8.23744
        11.8232 7.76256 11.8232 7.46967 11.5303L3.21967 7.28033C2.92678 6.98744 2.92678 6.51256
        3.21967 6.21967C3.51256 5.92678 3.98744 5.92678 4.28033 6.21967L8 9.93934L11.7197
        6.21967C12.0126 5.92678 12.4874 5.92678 12.7803 6.21967Z"
      :fill="color"
    />
  </svg>
</template>

<script lang="ts">
import Vue from 'vue';

export default Vue.extend({
  name: 'CgIconSelectChevron',
  props: {
    width: {
      type: [Number, String],
      required: false,
      default: 16,
    },
    height: {
      type: [Number, String],
      required: false,
      default: 16,
    },
    color: {
      type: String,
      required: false,
      default: '#24292E',
    },
  },
});
</script>
